<div class="page" fxLayout="row" fxLayoutAlign="center center">
    <div class="pane" fxLayout="column" fxLayoutAlign="start center">
        <div class="logo">
            <img src="/assets/kempower-logo.svg" />
        </div>

        <div *ngIf="loggingIn" class="text">
            <div class="subtitle">Logging in to ChargEye</div>
            <div class="desc">Please wait while we are logging you in...</div>
        </div>

        <div *ngIf="loginFailed" class="text failed">
            <div class="subtitle">Login failed</div>
            <div class="desc">Please try again.</div>
            <div class="reason">{{ loginFailedReason }}</div>
        </div>
    </div>
</div>
